// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"vy_a bhg_b bhg_wb"};